import type { EventCategoryListResponse } from "@cdt/shared";
import { useQuery } from "@tanstack/react-query";

import { fetchCategories } from "@/lib/categoriesApi";

export const CATEGORIES_QUERY_KEY = ["categories"] as const;

export function useCategoriesQuery() {
  return useQuery<EventCategoryListResponse>({
    queryKey: CATEGORIES_QUERY_KEY,
    queryFn: fetchCategories,
    staleTime: 10_000,
  });
}
